export const abattoirs = [
        {
            category: 'Stoka za klanje u Evropskoj uniji',
            text: 'Cene stoke za klanje u Evropskoj uniji',
            config: 'euAbattoirs',
            subcategories:[
            {
                name: 'Junad',
                text: 'Cene junadi za klanje u Evropskoj uniji'
            },
            {
                name: 'Bikovi',
                text: 'Cene bikova za klanje u Evropskoj uniji'
            },
            {
                name: 'Mladi bikovi',
                text: 'Cene mladih bikova za klanje u Evropskoj uniji'
            },
            {
                name: 'Goveda',
                text: 'Cene goveda za klanje u Evropskoj uniji'
            },
            {
                name: 'Krave',
                text: 'Cene krava za klanje u Evropskoj uniji'
            },
            {
                name: 'Junice',
                text: 'Cene junica za klanje u Evropskoj uniji'
            },
            {
                name: 'Svinje',
                text: 'Cene svinja za klanje u Evropskoj uniji'
            }
        ]
        },
        {
            category: 'Svinjski proizvodi u Evropskoj uniji',
            text: 'Cene svinjskih proizvoda u Evropskoj uniji',
            source: 2,
            subcategories:[
            {
                name: 'Trup',
                text: 'Cene svinjskog trupa u Evropskoj uniji'
            },
            {
                name: 'Šunka',
                text: 'Cene svinjske šunka u Evropskoj unijii'
            },
            {
                name: 'Pečenica',
                text: 'Cene svinjske pečenice u Evropskoj uniji'
            },
            {
                name: 'Mleveno meso',
                text: 'Cene svinjskog mlevenog mesa u Evropskoj uniji'
            },
            {
                name: 'Plećka',
                text: 'Cene svinjske plećke u Evropskoj uniji'
            } 
        ]
        }
    ]
